module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "xzlj"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('img', {
    staticClass: "dhqh",
    attrs: {
      "src": require("./img/pic@3x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "downloadButton",
    on: {
      "click": function($event) {
        _vm.judgePhoneType()
      }
    }
  }, [_vm._v("立即下载")])]), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.show,
      "id": "tips"
    }
  }, [_c('img', {
    staticClass: "jt",
    attrs: {
      "src": require("./img/icon@2x.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sb"
  }, [_c('img', {
    attrs: {
      "src": require("./img/①@3x.png")
    }
  }), _vm._v(" 点击右上角的 ‘‘...’’\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sb"
  }, [_c('img', {
    attrs: {
      "src": require("./img/②@3.png")
    }
  }), _vm._v(" 选择“在浏览器中打开”\n  ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "wrapper-logo"
  }, [_c('img', {
    staticClass: "imglog",
    attrs: {
      "src": require("./img/logo@3x.png"),
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2342a476"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xzlj/xzlj.vue
// module id = 871
// module chunks = 2